import { API } from '@/config';

import {
  FILL_POLLY_CONFIG_LIST,
} from './mutations-types';

export default {
  async getPollyConfigList({ commit }) {
    try {
      const { records, total } = (await API.get('/dictionaries/getPollyConfigList')).data.data;
      commit(FILL_POLLY_CONFIG_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },
};
